import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

function Fellowship() {
  const mainRef = useRef<HTMLHeadingElement>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    document.title = "Fellowship Program - Nclude Portal";
  }, [navigate]);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;
  const userNumber = localStorage.getItem("userPhoneNumber");
  const participantId = userNumber ? (userNumber.startsWith("+") ? userNumber : `+91${userNumber}`) : "+919876543210";

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="Fellowship" />
        <main className="doc-container voice-agent-page" tabIndex={-1} id="main-content">
          <section className="landing-page" aria-labelledby="fellowship-heading">
            <h1 className="display-title" id="fellowship-heading" ref={mainRef} tabIndex={-1}>
              Fellowship Program
            </h1>
            <div 
              className="content-container dashboard-container" 
              style={{ 
                height: "auto", 
                minHeight: "unset", 
                padding: isMobile ? "1.5rem 1rem" : "2rem 2rem",
                justifyContent: "center",
                marginTop: "1.5rem"
              }}
            >
              <h2 style={{ fontWeight: "600", fontSize: isMobile ? "1.8rem" : "2.2rem", textAlign: "center" }}>
                Welcome to the I-Stem Fellowship Program
              </h2>
              <p className="display-7" style={{ width: isMobile ? "90%" : "60%", margin: "1rem auto" }}>
                We are conducting a screening and enrollment process to identify
                talented individuals with disabilities across India. The interview
                takes 15–20 minutes.
              </p>
              <p style={{ fontWeight: "600", fontSize: isMobile ? "1.1rem" : "1.3rem", marginTop: "1rem", color:"#FFD700" }}> 
                Last date to apply: 15 July 2026
              </p> 
              <div 
                className="agent-container" 
                style={{ 
                  marginTop: "1.5rem", 
                  width: "100%",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    width: "fit-content"
                  }}
                >
                  <start-conversation-widget
                    agent-id="d657fc3e-43d0-4457-b913-452888b97962"
                    public-key="org_sec_xZQDkl6BMhH3Hr0jw8F5sPd6n7wyAoCS1lNwMYOsM6Y"
                    participant-id={participantId}
                    width={isMobile ? "240" : "320"}
                    height={isMobile ? "48" : "64"}
                    position="static"
                    mode="inline"
                    button-text="Begin Screening"
                    title="Start your interview"
                    description="Start a conversation with our Fellowship Program Screening Agent"
                    button-background="#1a1d2e"
                    button-text-color="#ffffff"
                    border-radius="8px"
                    show-waveform="true"
                    waveform-bar-count="8"
                    waveform-bar-color="#4b5563"
                    waveform-active-bar-color="#22D3EE"
                    waveform-height="28"
                    waveform-width="4"
                    waveform-animation-speed="50"
                  />
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default Fellowship;
